var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{attrs:{"label-cols":"3","label":_vm.$t( 'components.forms.user-settings-form.language' )}},[_c('LanguageChooser',{attrs:{"label":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }